module.exports = __webpack_public_path__ + "static/media/objetivo.d06fd184.jpg";